import { render } from "./SharedCharges.vue?vue&type=template&id=344ca230"
import script from "./SharedCharges.vue?vue&type=script&lang=js"
export * from "./SharedCharges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__